import { usePage } from "@inertiajs/react"
import { useEffect, useRef } from "react"

import type { SharedProps } from "@/types"

declare global {
  interface Window {
    posthog?: {
      identify: (
        distinctId: string,
        properties?: Record<string, unknown>,
      ) => void
      reset: () => void
    }
  }
}

export function usePostHogIdentify() {
  const { auth } = usePage<SharedProps>().props
  const identifiedRef = useRef<number | null>(null)

  useEffect(() => {
    if (!window.posthog) return

    if (auth?.user) {
      if (identifiedRef.current !== auth.user.id) {
        window.posthog.identify(String(auth.user.id), {
          email: auth.user.email,
          name: auth.user.name,
        })
        identifiedRef.current = auth.user.id
      }
    } else if (auth && identifiedRef.current !== null) {
      // Logged out: reset so the *next* login is honored. PostHog will not
      // switch an already-identified distinct_id to a new user without a
      // reset() first — without this, the second person to sign in on a
      // browser keeps the previous (or anonymous) distinct_id. The `auth &&`
      // guard avoids resetting on pages that don't share auth at all.
      window.posthog.reset()
      identifiedRef.current = null
    }
  }, [auth])
}
